import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-bairro',
  templateUrl: './text-bairro.component.html',
  styleUrls: ['./text-bairro.component.scss'],
  viewProviders: [ParentFormGroup ]
})
export class TextBairroComponent implements OnInit {
  
  constructor() {}

  ngOnInit() {}

}
